const strings = {
  toasts: {
    callFailedOutboundTitle:
      'The person you are trying to call is not online and does not have a voicemail box.',
    activateWhileOfferedCall:
      'You cannot activate the web phone while being offered a call.',
    callEndedByRemoteParty: 'The other party ended the call.',
  },
} as const;

export default strings;
